import axios from '../utils/axios'

// 获取地区
export function getAreaList(params) {
  return axios.get('api/region/area.json', {params});
}